export default __webpack_public_path__ + "static/media/pexels-ivan-samkov-4989175.3416211e.jpg";